<template>
  <div
    v-for="capacity in capacities"
    :key="capacity.year"
  >
    {{ capacity.year + ':' }} {{ capacity.capacity.toLocaleString('de-DE') + ' m' }}
  </div>
</template>

<script lang="ts" setup>
import type {PropType} from 'vue'
import type {Capacity} from '@/api/modules/companies'

defineProps({
  capacities: {
    type: Array as PropType<Array<Capacity>>,
    default: () => [],
    required: true,
  },
})
</script>

<style scoped></style>
